/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordAuthResponse
 */
export interface DiscordAuthResponse {
    /**
     * 
     * @type {string}
     * @memberof DiscordAuthResponse
     */
    url: string;
}

export function DiscordAuthResponseFromJSON(json: any): DiscordAuthResponse {
    return DiscordAuthResponseFromJSONTyped(json, false);
}

export function DiscordAuthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordAuthResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function DiscordAuthResponseToJSON(value?: DiscordAuthResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}


